import React from 'react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import rowingBackground from '../images/about-us/rowing-UT-Polaris.jpg';
import swimmingPhoto from '../images/about-us/swimming-polaris.png';
import '../styles/about-page.css';

export default function AboutPage() {
    return (
        <main className="about-page">
            <PublicHeader />

            {/* ── Hero (solid black, centred) ── */}
            <section className="about-hero">
                <div className="about-hero-inner">
                    <h1 className="about-hero-heading">
                        College Counseling &amp; NIL Education.
                        <br />
                        Connected.
                    </h1>
                </div>
            </section>

            {/* ── Our Mission (photo card) ── */}
            <section className="about-mission">
                <div
                    className="about-mission-card"
                    style={{ backgroundImage: `url(${rowingBackground})` }}
                >
                    <div className="about-mission-overlay" />
                    <div className="about-mission-inner">
                        <p className="about-section-label">Our Mission</p>
                        <h2 className="about-mission-heading">
                            At Polaris Athlete, our mission is to empower student-athletes to
                            navigate their journey with clarity, confidence, and purpose.
                        </h2>
                        <p className="about-mission-body">
                            We believe that{' '}
                            <strong>College Counseling and NIL Education should be connected</strong>.
                            We intentionally connect academic preparation, athletic development, and
                            personal growth into one cohesive path. We help each student-athlete align
                            their goals, discover their voice, and unlock opportunities both within and
                            beyond their sport.
                        </p>
                        <p className="about-mission-body">
                            Our work is rooted in the belief that purposeful preparation builds lifelong
                            confidence, equipping student-athletes not only for college but also for
                            leadership, impact, and success beyond the game.
                        </p>
                    </div>
                    <p className="about-mission-caption">Polaris Athlete Mentor, Ellie Rodriguez, Women&apos;s Rowing</p>
                </div>
            </section>

            {/* ── Value proposition ── */}
            <section className="about-value">
                <div className="about-value-inner">
                    <h2 className="about-value-heading">
                        Polaris Athlete connects school, sport, college, career, and life, bringing
                        together the guidance, resources, experiences, and people student-athletes need
                        to prepare for what&apos;s next.
                    </h2>
                </div>
            </section>

            {/* ── Photo + red panel split ── */}
            <section className="about-split">
                <div className="about-split-inner">
                    <div className="about-split-grid">
                        <div className="about-split-media">
                            <img src={swimmingPhoto} alt="Polaris student-athlete swimming" />
                        </div>
                        <div className="about-split-panel">
                            <h2 className="about-split-heading">
                                Built alongside leading educators and industry experts, Polaris helps
                                schools develop not just better athletes, but future-ready young people.
                            </h2>
                        </div>
                    </div>
                    <p className="about-split-caption">Jayden Edmonson, Men&apos;s Swimming</p>
                </div>
            </section>

            {/* ── The student-athlete experience has changed ── */}
            <section className="about-changed">
                <div className="about-changed-card">
                    <div className="about-changed-left">
                        <h2 className="about-changed-heading">
                            The student-athlete experience has changed.
                        </h2>
                        <h2 className="about-changed-heading">
                            The support surrounding it needs to change, too.
                        </h2>
                    </div>
                    <div className="about-changed-right">
                        <p className="about-changed-body">
                            Empowering student-athletes to navigate their journey with clarity,
                            confidence, and purpose.
                        </p>
                        <p className="about-changed-body">
                            Today&apos;s student-athletes are navigating more than academics, athletics,
                            and college recruiting. They are building personal brands. Making financial
                            decisions. Exploring NIL opportunities. Thinking about careers. Managing their
                            digital presence. And making choices that can impact their future long before
                            they graduate.
                        </p>
                        <p className="about-changed-body about-changed-body--bold">
                            The opportunity is enormous.
                        </p>
                        <p className="about-changed-body about-changed-body--bold">
                            So is the need for guidance.
                        </p>
                    </div>
                </div>
            </section>

            <PublicFooter />
        </main>
    );
}
